import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {CitizenVerifyPassword} from './citizen-verify-password.model';

export const loadCitizenVerifyPasswords = createAction(
  '[CitizenVerifyPassword/API] Load CitizenVerifyPasswords',
  props<{ citizenVerifyPasswords: CitizenVerifyPassword[] }>()
);

export const addCitizenVerifyPassword = createAction(
  '[CitizenVerifyPassword/API] Add CitizenVerifyPassword',
  props<{ citizenVerifyPassword: CitizenVerifyPassword }>()
);

export const upsertCitizenVerifyPassword = createAction(
  '[CitizenVerifyPassword/API] Upsert CitizenVerifyPassword',
  props<{ citizenVerifyPassword: CitizenVerifyPassword }>()
);

export const addCitizenVerifyPasswords = createAction(
  '[CitizenVerifyPassword/API] Add CitizenVerifyPasswords',
  props<{ citizenVerifyPasswords: CitizenVerifyPassword[] }>()
);

export const upsertCitizenVerifyPasswords = createAction(
  '[CitizenVerifyPassword/API] Upsert CitizenVerifyPasswords',
  props<{ citizenVerifyPasswords: CitizenVerifyPassword[] }>()
);

export const updateCitizenVerifyPassword = createAction(
  '[CitizenVerifyPassword/API] Update CitizenVerifyPassword',
  props<{ citizenVerifyPassword: Update<CitizenVerifyPassword> }>()
);

export const updateCitizenVerifyPasswords = createAction(
  '[CitizenVerifyPassword/API] Update CitizenVerifyPasswords',
  props<{ citizenVerifyPasswords: Update<CitizenVerifyPassword>[] }>()
);

export const deleteCitizenVerifyPassword = createAction(
  '[CitizenVerifyPassword/API] Delete CitizenVerifyPassword',
  props<{ id: string }>()
);

export const deleteCitizenVerifyPasswords = createAction(
  '[CitizenVerifyPassword/API] Delete CitizenVerifyPasswords',
  props<{ ids: string[] }>()
);

export const clearCitizenVerifyPasswords = createAction(
  '[CitizenVerifyPassword/API] Clear CitizenVerifyPasswords'
);


//CUSTOM



export const citizenVerifyOtpPassword = createAction(
  '[CitizenVerifyPassword/API] citizen Verify Otp Password',
  props<{ passwordOtp?: string }>()
);
